import { useAppDispatch, useAppSelector } from 'app/hooks';
import { Button } from 'components/Button/Button';
import { InputComponent } from 'components/Input/Input';
import { getCartFromLS } from 'helpers/localstorage-helper';
import { CountryDropdown } from 'pages/Auth/CountryDropdown';
import { ChangeEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { purchasePackages } from 'services/auth/packages.service';
import { colors, RightIcon } from 'styles';
import { H3, H4, H5, P1, P2 } from '../../styles/FontStyles';
import { Div, Img, Separator } from '../../styles/Styles';
import { RadioButton } from './ShippingBilling.styled';
import Spinner from 'components/Spinner/Spinner';

export const ShippingBilling = () => {
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [address, setAddress] = useState<string>('');
  const [postalCode, setPostalCode] = useState<string>('');
  const [city, setCity] = useState<string>('');
  const [country, setCountry] = useState<any>('');
  const [firstNameBilling, setFirstNameBilling] = useState<string>('');
  const [lastNameBilling, setLastNameBilling] = useState<string>('');
  const [addressBilling, setAddressBilling] = useState<string>('');
  const [postalCodeBilling, setPostalCodeBilling] = useState<string>('');
  const [cityBilling, setCityBilling] = useState<string>('');
  const [countryBilling, setCountryBilling] = useState<any>('');
  const [selected, setSelected] = useState<string>('option1');
  const card = getCartFromLS();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { loading } = useAppSelector((state) => state.packages);

  const payment = () => {
    const order: {
      packageId: any;
      currencyType: string;
      networkType: any;
      navigate: any;
      shippingInfo: {
        firstName: string;
        lastName: string;
        address: string;
        postalCode: string;
        city: string;
        country: any;
        countryCode: any;
      };
      billingInfo?: {
        firstName: string;
        lastName: string;
        address: string;
        postalCode: string;
        city: string;
        country: any;
        countryCode: any;
      };
    } = {
      packageId: card.id,
      currencyType: 'usdc',
      networkType: card.selectedNetwork,
      navigate: navigate,
      shippingInfo: {
        firstName,
        lastName,
        address,
        postalCode,
        city,
        country: country.label,
        countryCode: country.value,
      },
    };

    if (selected === 'option2') {
      order.billingInfo = {
        firstName: firstNameBilling,
        lastName: lastNameBilling,
        address: addressBilling,
        postalCode: postalCodeBilling,
        city: cityBilling,
        country: countryBilling.label,
        countryCode: countryBilling.value,
      };
    }

    dispatch(purchasePackages(order));
  };

  return (
    <>
      {loading && <Spinner fullscreen={true} transparent />}
      <Div $flex $gap='40px' $width='100%' $columnSM>
        <Div $width='30%' $widthSM='100%'>
          <H3 mb='20' color={colors.white}>
            Shipping address
          </H3>
          <InputComponent
            placeholder='Name'
            value={firstName}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setFirstName(e.target.value)
            }
          />
          <InputComponent
            placeholder='Surname'
            value={lastName}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setLastName(e.target.value)
            }
          />
          <InputComponent
            placeholder='Address'
            value={address}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setAddress(e.target.value)
            }
          />
          <Div $flex $gap='10px'>
            <Div $width='50%'>
              <InputComponent
                placeholder='Postal Code'
                value={postalCode}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setPostalCode(e.target.value)
                }
              />
            </Div>
            <Div $width='50%'>
              <InputComponent
                placeholder='City'
                value={city}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setCity(e.target.value)
                }
              />
            </Div>
          </Div>
          <CountryDropdown country={country} setCountry={setCountry} />
        </Div>
        <Div $width='30%' $widthSM='100%'>
          <H3 mb='20' color={colors.white}>
            Billing address
          </H3>
          <Div $flex $alignCenter $gap='5px' $mb='12px'>
            <RadioButton
              type='radio'
              name='options'
              value='option1'
              checked={selected === 'option1'}
              onChange={(e) => setSelected(e.target.value)}
            />
            <P1 color={colors.white}>Same as shipping address</P1>
          </Div>
          <Div $flex $alignCenter $gap='5px' $mb='20px'>
            <RadioButton
              type='radio'
              name='options'
              value='option2'
              checked={selected === 'option2'}
              onChange={(e) => setSelected(e.target.value)}
            />
            <P1 color={colors.white}>Bill to different address</P1>
          </Div>

          {selected === 'option2' && (
            <Div $mobile>
              <InputComponent
                placeholder='Name'
                value={firstNameBilling}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setFirstNameBilling(e.target.value)
                }
              />
              <InputComponent
                placeholder='Surname'
                value={lastNameBilling}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setLastNameBilling(e.target.value)
                }
              />
              <InputComponent
                placeholder='Address'
                value={addressBilling}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setAddressBilling(e.target.value)
                }
              />
              <Div $flex $gap='10px'>
                <Div $width='50%'>
                  <InputComponent
                    placeholder='Postal Code'
                    value={postalCodeBilling}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      setPostalCodeBilling(e.target.value)
                    }
                  />
                </Div>
                <Div $width='50%'>
                  <InputComponent
                    placeholder='City'
                    value={cityBilling}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      setCityBilling(e.target.value)
                    }
                  />
                </Div>
              </Div>
              <CountryDropdown
                country={countryBilling}
                setCountry={setCountryBilling}
              />
            </Div>
          )}
        </Div>
        <Div $width='40%' $widthSM='100%'>
          <Div $box $flex $column>
            <H3 mb='20' color={colors.white}>
              Order Summary
            </H3>

            <Div $flex $alignCenter $gap='20px' $mb='32px'>
              <Div $box $borderRadius='8px' $p='5px 0'>
                <Img src={card.imageUrl} $height='75px' $heightSM='60px' />
              </Div>
              <H4 color={colors.white}>{card.name}</H4>
            </Div>

            {/* <InfoValue info='Subtotal' value='$50' />
            <InfoValue info='Shipping' value='$4' /> */}
            <Separator $m='20px 0' />
            <InfoValue info='Total (Tax incl.)' value={`$${card.price}`} />

            <Div $mt='24px'>
              <Button
                $color={colors.blue}
                disabled={
                  !firstName ||
                  !lastName ||
                  !address ||
                  !postalCode ||
                  !city ||
                  !country ||
                  (selected === 'option2' &&
                    (!firstNameBilling ||
                      !lastNameBilling ||
                      !addressBilling ||
                      !postalCodeBilling ||
                      !cityBilling ||
                      !countryBilling))
                }
                onClick={() => payment()}
              >
                <Div $flex $between $alignCenter $width='100%' $p='0 12px'>
                  <H5>${`${card.price}`} USDC</H5>

                  <Div $flex $alignCenter>
                    <H5>Go to Payment</H5>
                    <RightIcon />
                  </Div>
                </Div>
              </Button>
            </Div>
          </Div>
        </Div>
      </Div>

      <Div $flex $gap='40px' $width='100%' $columnSM $desktop>
        <Div $width='30%' $widthSM='100%'>
          {selected === 'option2' && (
            <Div $desktop>
              <H3 mb='20' mt='20' color={colors.white}>
                Billing address
              </H3>
              <InputComponent
                placeholder='Name'
                value={firstNameBilling}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setFirstNameBilling(e.target.value)
                }
              />
              <InputComponent
                placeholder='Surname'
                value={lastNameBilling}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setLastNameBilling(e.target.value)
                }
              />
              <InputComponent
                placeholder='Address'
                value={addressBilling}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setAddressBilling(e.target.value)
                }
              />
              <Div $flex $gap='10px'>
                <Div $width='50%'>
                  <InputComponent
                    placeholder='Postal Code'
                    value={postalCodeBilling}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      setPostalCodeBilling(e.target.value)
                    }
                  />
                </Div>
                <Div $width='50%'>
                  <InputComponent
                    placeholder='City'
                    value={cityBilling}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      setCityBilling(e.target.value)
                    }
                  />
                </Div>
              </Div>
              <CountryDropdown
                country={countryBilling}
                setCountry={setCountryBilling}
              />
            </Div>
          )}
        </Div>

        <Div $width='30%' $widthSM='100%'></Div>
        <Div $width='40%' $widthSM='100%'></Div>
      </Div>

      {selected === 'option2' && (
        <Div $flex $gap='40px' $width='100%' $columnSM $mt='25px'>
          <Div $width='35%' $widthSM='100%'></Div>
          <Div $width='30%' $widthSM='100%'></Div>
          <Div $width='35%' $widthSM='100%'></Div>
        </Div>
      )}
    </>
  );
};

const InfoValue = ({ info, value }: any) => (
  <Div $flex $between $alignCenter $m='5px 0'>
    <P2 color={colors.white}>{info}</P2>
    <P2 color={colors.white}>{value}</P2>
  </Div>
);
